import React from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import getOr from '../../utils/getOr';
var getMessageArray = getOr([])('data._messages');
function getMessages(msg) {
  return msg.map(function (val) {
    return "".concat(val.message.desc, ":\n").concat(val.message.detail);
  }).join('\n\n');
}
var getListOfErrors = compose(getMessages, getMessageArray);
export function ErrorFormatter(_ref) {
  var error = _ref.error,
    i18nPrefix = _ref.i18nPrefix,
    defaultI18nKey = _ref.defaultI18nKey,
    intl = _ref.intl,
    children = _ref.children;
  var errorMsg = '';
  var i18nKey = i18nPrefix + error.status;
  if (intl.messages[i18nKey]) {
    errorMsg = intl.formatMessage({
      id: i18nKey
    });
  } else if (error.data) {
    errorMsg = getListOfErrors(error);
  } else {
    var defaultMessage = intl.formatMessage({
      id: i18nPrefix + defaultI18nKey
    }, {
      status: error.status
    });
    errorMsg = intl.formatMessage({
      id: i18nKey,
      defaultMessage: defaultMessage
    }, {
      status: error.status
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(errorMsg));
}
export default injectIntl(ErrorFormatter);